/**
 * PauseToggler クラス
 *
 * 指定した要素に対し、クリックまたはEnterキーで is-paused クラスをトグルするユーティリティ。
 *
 * - 単一要素ごとに一時停止・再開のトグル機能を付与可能
 * - フォーカス可能な状態にし、キーボード操作にも対応
 *
 * @example
 *   new PauseToggler('.js-hero-gallery');
 *   new PauseToggler(document.querySelector('.js-members-track'));
 *
 * @param {Element|string} target 対象のDOM要素またはセレクタ文字列
 *
 * 注意:
 * - is-pausedクラスのスタイルはSCSS側で制御してください。
 * - 複数要素に同時に付与したい場合はforEach等でインスタンス化してください。
 */
export class PauseToggler {
	/**
	 * @param {Element|string} target 単一のDOM要素またはセレクタ文字列
	 */
	constructor(target) {
		this.el =
			typeof target === 'string' ? document.querySelector(target) : target;
		if (!this.el) return;
		this.init();
	}

	init() {
		// クリックでトグル
		this.el.addEventListener('click', () => {
			this.el.classList.toggle('is-paused');
		});

		// Enterキーでトグル（フォーカス可能にする）
		this.el.setAttribute('tabindex', '0');
		this.el.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') {
				this.el.classList.toggle('is-paused');
			}
		});
	}
}
